const $ = jQuery.noConflict();

'use strict';

const VariationScript = {

	// properties
	$domForm: null,
	$domLoader: null,
	$domSubmit: null,
	$domResponse: null,
	$termTitles: [],
	$latestDate: null,

	// initialize
	init: function() {
		$(document).ready(function() {
			const loader = $('.loader-wrapp');
			const sectionContainer = $('#sectionContainer');
			// Show loader initially
			loader.show();
			sectionContainer.hide();
			// Function to show section container and hide loader
			function showSection() {
				loader.hide();
				sectionContainer.css('display', 'block');
			}
			// If section is already loaded
			if (sectionContainer.complete) {
				showSection();
			} else {
				// If section is still loading, wait for load event
				sectionContainer.on('load', showSection);
			}
			$(document).on('ajaxComplete', function() {
				showSection();
			});

			$('.variable-item').on('click', function(event) {
				if ($(this).hasClass('selected') && !$(this).hasClass('custom-click-fws')) {
					event.stopPropagation(); // Stop event propagation
				} else {
					$('ul[data-attribute_name="attribute_pa_table-base"] .variable-item.custom-click-fws').removeClass('custom-click-fws');
					$('ul[data-attribute_name="attribute_pa_table-top"] .variable-item.custom-click-fws').removeClass('custom-click-fws');
				}
			});
		});
		$(document).ready(function() {
			$('ul[data-attribute_name="attribute_size"] .variable-item').on('click', function() {
				// Remove 'selected' class from all items
				$('ul[data-attribute_name="attribute_pa_table-base"] .variable-item.selected').addClass('custom-click-fws').click();
				$('ul[data-attribute_name="attribute_pa_table-top"] .variable-item.selected').addClass('custom-click-fws').click();
				// Handling click event for first items with delay
				setTimeout(function() {
					$('ul[data-attribute_name="attribute_pa_table-base"] .variable-item:not(".disabled"):first').click();
					$('ul[data-attribute_name="attribute_pa_table-top"] .variable-item:not(".disabled"):first').click();
				}, 100);
			});
		});
		// hide tooltip
		$('.variable-item').on('mouseenter', function() {
			const $notooltip = $(this).attr('title');
			$(this).attr('notooltip', $notooltip);
			$(this).attr('title', '');
		}).on('mouseleave', function() {
			const $notooltip = $(this).attr('notooltip');
			$(this).attr('title', $notooltip);
			$(this).removeAttr('notooltip');
		});

		$('form.variations_form').on('found_variation', function(event, variation) {
			VariationScript.sendRequest(variation.variation_id);
			$('#container canvas').hide();
			const selectedChairBase = $('ul[data-attribute_name="attribute_pa_chair-bases"] .image-variable-item.selected').attr('dateexpected');
			const selectedChairSeat = $('ul[data-attribute_name="attribute_pa_chair-seats"] .image-variable-item.selected').attr('dateexpected');
			const selectedTableBase = $('ul[data-attribute_name="attribute_pa_table-base"] .image-variable-item.selected').attr('dateexpected');
			const selectedTableTop = $('ul[data-attribute_name="attribute_pa_table-top"] .image-variable-item.selected').attr('dateexpected');
			const selectedChairBaseDate = new Date(selectedChairBase);
			const selectedChairSeatDate = new Date(selectedChairSeat);
			const selectedTableBaseDate = new Date(selectedTableBase);
			const selectedTableTopDate = new Date(selectedTableTop);
			if(selectedChairBaseDate || selectedChairSeatDate){
				VariationScript.$latestDate = selectedChairBaseDate > selectedChairSeatDate ? selectedChairBase : selectedChairSeat;
			} else if(selectedTableBaseDate || selectedTableTopDate) {
				VariationScript.$latestDate = selectedTableBaseDate > selectedTableTopDate ? selectedTableBase : selectedTableTop;
			} else {
				VariationScript.$latestDate = '';
			}
		});

		$('.image-variable-item').each(function() {
			let backgroundColor = $(this).find('.variable-item-image').attr('src');
			backgroundColor = backgroundColor.replace('-50x50', '');
			const title = $(this).data('title');
			const taxonomy = $(this).parent().parent().find('select').attr('id');

			VariationScript.$termTitles.push({title: title, taxonomy: taxonomy});
			// if item is premium add "premium" class on the info-popup
			$(this).append('<div class="info-popup"><div class="info-popup__inner"><div class="info-popup__color" style="background-image: url(' + backgroundColor + ');background-position: center;background-repeat: no-repeat;background-size: cover;"></div> <div><span class="premium-item"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" fill="#fff"/></svg>Premium</span></span><span class="info-popup__name">' + title + '</span><span class="info-popup__info">Textured woven vinyl</span><p class="dateExpected"></p><p class="termPrice"></p></div></div></div>');
		});
		VariationScript.getTerms();
		/*$('#product_qty').on('change input', function() {
			const currentQty = $('.in-stock').text();
			let QtyNumber = '';
			$('.single-product__qty-input').attr('qty-number', '0');
			if(currentQty) {
				QtyNumber = parseInt(currentQty.match(/\d+/g).join(''));
			} else {
				QtyNumber = 0;
			}
			$('.single-product__qty-input').attr('qty-number', parseInt(QtyNumber));
			setTimeout(() => {
				if(parseInt($('#product_qty').val()) <= parseInt($('.single-product__qty-input').attr('qty-number'))) {
					VariationScript.setInStock(QtyNumber);
				} else {
					VariationScript.setOutOfStock();
				}
			}, 200);
		});*/
	},

	// send form submission
	sendRequest: function($variationID) {
		const body = {
			nonce: window.fwsLocalized.nonce,
			action: 'get3dModel',
			variationId: $variationID
		};
		$.ajax({
			url: window.fwsLocalized.ajaxUrl,
			type: 'POST',
			dataType: 'JSON',
			data: body,
			success: (response) => {
				if (response.success) {
					const currentQty = jQuery('.in-stock').text();
					let QtyNumber = '';
					const inputedQty = jQuery('#product_qty').val();
					if(currentQty) {
						QtyNumber = parseInt(currentQty.match(/\d+/g).join(''));
					}
					if(parseInt(QtyNumber) < parseInt(inputedQty)) {
						VariationScript.setOutOfStock();
					} else if(QtyNumber){
						VariationScript.setInStock(QtyNumber);
					} else {
						VariationScript.setOutOfStock();
					}
					const viewerDiv = document.querySelector('.Model3d-image_viewer');
					//const existingModelViewer = viewerDiv.querySelector('model-viewer');
					const environmentSettup = jQuery('.single-product__image-3d').attr('data-environment');
					let environmentDisplay = '';
					if(environmentSettup){
						environmentDisplay = 'environment-image=' + environmentSettup;
					} else {
						environmentDisplay = '';
					}
					let modelUrl = '';
					let modelName = '';
					let placeholder = '';
					if(response.data && response.data.Model3d !== ''){
						if(response.data.Model3d.url !== '') {
							modelUrl = response.data.Model3d.url;
							modelName = response.data.Model3d.name;
						}
						if (response.data.Placeholder) {
							placeholder = response.data.Placeholder.url;
						}
						const newElement = document.createElement('div');
						const degvalue = (modelUrl.indexOf('702_OL') !== -1 || modelUrl.indexOf('702_ol') !== -1) ? 20 : 205;

						newElement.innerHTML = '<model-viewer id="reveal" loading="eager" camera-controls touch-action="pan-y" disable-pan ' + environmentDisplay + ' camera-orbit="' + degvalue + 'deg 82deg 30m" auto-rotate poster="'+ placeholder +'" src="'+ modelUrl +'" shadow-intensity="1" alt="'+ modelName +'" camera-orbit="-30deg auto auto" max-camera-orbit="auto 80deg auto"></model-viewer>';
						// Check if the existing model-viewer has the same src URL
						//if (existingModelViewer && response.data.Model3d.url && existingModelViewer.getAttribute('src') === response.data.Model3d.url) {
						if (response.data.Model3d.url) {
							console.log('The model is already loaded with the same URL.');
						} else {
							viewerDiv.innerHTML = '';
							viewerDiv.appendChild(newElement);
						}
					} else if(viewerDiv) {
						viewerDiv.innerHTML = '';
					}
				}
				$('#container canvas').hide();
			},
		});
	},


	setInStock: function(QtyNumber) {
		const currentCategory = $('.single-product__info-qty').attr('current-category').toLowerCase();
		const qtyTreshold = currentCategory === 'chairs' ? 10 : 2;
		$('.single-product__qty-input').attr('qty-number', QtyNumber);
		let availableText = '';
		if(QtyNumber <= qtyTreshold) {
			availableText = '<span style="color:#24B833">' + QtyNumber + ' items available</span>';
			$('.single-product__info-qty-state-name').html(availableText);
			$('.single-product_date-expected').text('');
			$('.single-product__info-qty-state').css('background-color', '#24B833');
			$('.single-product_date-expected').text('');
		} else {
			availableText = 'Available';
			$('.single-product__info-qty-state-name').text(availableText);
			$('.single-product_date-expected').text('');
			$('.single-product__info-qty-state').css('background-color', '#24B833');
		}
	},

	setOutOfStock: function() {
		const qtyFirst = $('.single-product__qty-input').attr('qty-number');
		if(qtyFirst !== '0') {
			$('.single-product__info-qty-state-name').html('On the way: <span style="color:#24B833">' + qtyFirst + ' items available</span>');
		} else {
			$('.single-product__info-qty-state-name').text('On the way');
		}
		if(VariationScript.$latestDate) {
			$('.single-product_date-expected').text('Expected ' + VariationScript.$latestDate + '.');
		} else {
			$('.single-product_date-expected').text('');
		}
		$('.single-product__info-qty-state').css('background-color', '#FFC555');
	},


	// Function to get cookie value by name
	getCookie: function(name) {
		// Construct regex pattern to match the cookie name
		let pattern = RegExp(name + '=.[^;]*');
		// Match the pattern against the document's cookies
		let matched = document.cookie.match(pattern);
		// If a match is found, return the cookie value
		if (matched) {
			let cookie = matched[0].split('=');
			return cookie[1];
		}
		// If no match is found, return null
		return null;
	},

	// send form submission
	getTerms: function() {
		const body = {
			action: 'getTermsID',
			termNames: VariationScript.$termTitles,
		};
		let $callText = '';
		let callTextAppended = false;
		let callSizeSearched = false;
		const divHtml = `
			<div class="single-product__info-qty-left">
				<div class="single-product__info-qty-wrap">
					<span class="single-product__info-qty-term_state"></span>
					<span class="single-product__info-qty-state-term_name"></span>
				</div>
			</div>
		`;
		$.ajax({
			url: window.fwsLocalized.ajaxUrl,
			type: 'POST',
			dataType: 'JSON',
			data: body,
			success: (response) => {
				if (response.success) {
					console.log(response);
					Object.keys(response.data.premium).forEach((title) => {
						// Find elements with the corresponding title attribute
						const elementsWithTitle = $(`.variable-item[data-title="${title}"]`);
						elementsWithTitle.addClass('premium');
						elementsWithTitle.find('.info-popup').addClass('premium');
					});
					// Loop through the data object
					Object.keys(response.data.data).forEach((title) => {
						const termData = response.data.data[title];
						if (!callTextAppended && termData.taxonomy === 'pa_table-top') {
							const $callText = '<p class="contact-us-text">Custom table sizes available <a href="/contact">Contact us!</a></p>';
							$('ul[data-attribute_name="attribute_size"]').parent().append($callText);
							callTextAppended = true;
						}
						// Find elements with the corresponding title attribute
						const elementsWithTitle = $(`.variable-item[data-title="${title}"]`);

						elementsWithTitle.append(divHtml);
						let textureFormated = termData.isColor ? termData.color : termData.modelImage;
						elementsWithTitle.find('.single-product__info-qty-wrap').append('<input type="hidden" class="texture-button" data-is-color="' + termData.isColor + '" data-model-template="' + termData.modelTemplate + '" data-table-size="' + termData.tableSize + '" data-part="' + termData.taxonomy + '" data-texture="' + textureFormated + '" data-bumpmap="' + termData.bumpMap + '" data-bumpmap-extrude="' + termData.bumpMapExtrude + '" data-metalness="' + termData.metalness + '" data-reflectivity="' + termData.reflectivity + '" data-scale="' + termData.scale + '" data-has-light="' + termData.isLight + '" data-x-offset="' + termData.xOffset + '" data-y-offset="' + termData.yOffset + '">');
						// Loop through each matching element
						elementsWithTitle.each(function(index, element) {
							$(element).css({
								'display': 'flex',
								'flex-direction': 'column',
								'justify-content': 'flex-start',
								'min-width': '116px',
								'min-height': '80px'
							});
							if($('body').hasClass('logged-in')){
								$(element).css({
									'min-height': '168px'
								});
							}
							$(element).find('.single-product__info-qty-term_state').css({
								'min-width': '8px',
								'width': '8px',
								'height': '8px',
								'min-height': '8px',
								'display': 'inline-block',
								'margin-right': '10px',
								'border-radius': '100%'
							});
						});
						// Add the term_description attribute to each matching element
						elementsWithTitle.find('.info-popup__name').text(termData.title);
						elementsWithTitle.find('.info-popup__info').text(termData.description);
						if(termData.expectedDate){
							elementsWithTitle.attr('dateExpected', termData.expectedDate);
							//elementsWithTitle.append('<p>' + termData.expectedDate + '</p>');
						}
						if(termData.termSKU){
							elementsWithTitle.attr('termSKU', termData.termSKU);
							//elementsWithTitle.append('<p>' + termData.expectedDate + '</p>');
						}
						if(termData.title){
							elementsWithTitle.attr('termNiceName', termData.title);
							//elementsWithTitle.append('<p>' + termData.expectedDate + '</p>');
						}
						if($('body').hasClass('logged-in')){
							if(termData.termAvailability){
								if(termData.termAvailability === 'available'){
									elementsWithTitle.find('.single-product__info-qty-term_state').css({
										'background-color': '#24B833'
									});
									elementsWithTitle.find('.single-product__info-qty-state-term_name').text('Available');
								} else if (termData.termAvailability === 'low_inventory'){
									elementsWithTitle.find('.single-product__info-qty-term_state').css({
										'background-color': '#FFC555'
									});
									elementsWithTitle.find('.single-product__info-qty-state-term_name').text('Low Inventory');
									elementsWithTitle.append('<p class="single-product__info-backordered">QTY: ' + termData.termQTY + '</p>');
								} else if(termData.termAvailability === 'backorder') {
									elementsWithTitle.find('.single-product__info-qty-term_state').css({
										'background-color': '#FF5555'
									});
									elementsWithTitle.find('.single-product__info-qty-state-term_name').text('Backordered');
									if(termData.expectedDate){
										// Parse the date string into a Date object
										const date = new Date(termData.expectedDate);

										// Get the month and day
										const month = date.getMonth() + 1; // Adding 1 because getMonth() returns zero-based index
										const day = date.getDate();

										// Format the date as desired (month/day)
										const formattedDate = month + '/' + day;
										elementsWithTitle.append('<p class="single-product__info-backordered">Available: ' + formattedDate + '</p>');
									}
								} else if(termData.termAvailability === 'made_to_order') {
									elementsWithTitle.find('.single-product__info-qty-term_state').css({
										'background-color': '#ADD8E6'
									});
									elementsWithTitle.find('.single-product__info-qty-state-term_name').text('Made to order');
									if(termData.expectedDate){
										elementsWithTitle.append('');
									}
								}
							}
							if(termData.termPrice){
								// Get the global markup value from cookie
								let globalMarkup = $('.global_markup-holder').data('global-markup');
								let categoryMarkup = $('.global_markup-holder').data('category-markup');
								let productMarkup = $('.global_markup-holder').data('product-markup');
								let hidePrices = $('.global_markup-holder').data('hide-prices');

								let priceWithoutDollarSign = termData.termPrice.replace('$', '');
								let endPrice = priceWithoutDollarSign;
								if(productMarkup && productMarkup !== '0'){
									endPrice = parseFloat(priceWithoutDollarSign) * (1 + parseFloat(productMarkup) / 100);
									endPrice = parseFloat(endPrice).toFixed(2);
								} else if(categoryMarkup && categoryMarkup !== '0'){
									endPrice = parseFloat(priceWithoutDollarSign) * (1 + parseFloat(categoryMarkup) / 100);
									endPrice = parseFloat(endPrice).toFixed(2);
								} else if (globalMarkup) {
									endPrice = parseFloat(priceWithoutDollarSign) * (1 + parseFloat(globalMarkup) / 100);
									endPrice = parseFloat(endPrice).toFixed(2);
								}
								if(hidePrices === 1){
									elementsWithTitle.append('<p class="single-product__info-price">$' + endPrice + '</p>');
								} else {
									elementsWithTitle.append('<p class="single-product__info-price"></p>');
								}
							}
						}
						const elementsSelectedWithTitle = $(`.variable-item.selected[data-title="${title}"]`);
						const sizeSelected = $('ul[data-attribute_name="attribute_size"] li.selected');

						if(sizeSelected.length > 0 && !callSizeSearched) {
							const termNiceTitle = sizeSelected.attr('data-title');
							const label = $(sizeSelected).parent().attr('aria-label'); // Get label text
							$('.js-selected-options-cards').append('<p class="single-product__info-selected-item">' + label + ': <span class="selected-val">' + termNiceTitle + '</span></p>');
							callSizeSearched = true;
						}
						if (elementsSelectedWithTitle.length > 0) {
							const termSKUValue = elementsSelectedWithTitle.attr('termSKU');
							const termNiceTitle = elementsSelectedWithTitle.attr('termnicename');
							const label = $(elementsSelectedWithTitle).parent().attr('aria-label'); // Get label text
							$('.js-selected-options-cards').append('<p class="single-product__info-selected-item">' + label + ': <span class="selected-val">' + termNiceTitle + ' ( SKU: ' + termSKUValue + ' )' + '</span></p>');
						}
					});
					if($('body').hasClass('logged-in')){
						let totalPrice = 0;
						let allEmpty = false;

						$('.image-variable-item.selected').each(function() {
							let priceText = $(this).find('.single-product__info-price').text().trim();
							if (priceText === '') {
								allEmpty = true;
								return false; // exit the loop if any price is empty
							}
							let price = parseFloat(priceText.replace(/[^\d.-]/g, ''));
							if (isNaN(price)) {
								allEmpty = true;
								return false; // exit the loop if any price is not a valid number
							}
							totalPrice += price;
						});

						if (allEmpty) {
							totalPrice = ''; // if any price is empty, set totalPrice to empty
							$('.single-product__info-total').hide();
							$('.single-product__info-total-amount').text('');
						} else {
							totalPrice = totalPrice.toFixed(2); // round totalPrice to 2 decimal places
							$('.single-product__info-total').show();
							$('.single-product__info-total-amount').text('$' + totalPrice);
						}
					}
				}
			},
		});
	}
};
export default VariationScript;